import { supabase } from './supabase'
import { Database } from '@/../database.types'

type Campaign = Database['public']['Tables']['campaigns']['Insert']

export async function createCampaign(campaign: Omit<Campaign, 'id' | 'created_at' | 'updated_at'>) {
  const id = crypto.randomUUID()

  // If the campaign is being created from a convergence, get the convergence image_url
  let imageUrl = campaign.image_url || null
  
  if (campaign.originating_convergence_id && !imageUrl) {
    try {
      const { data: convergence } = await supabase
        .from('convergences')
        .select('image_url')
        .eq('id', campaign.originating_convergence_id)
        .single()
      
      if (convergence?.image_url) {
        imageUrl = convergence.image_url
      }
    } catch (error) {
      console.warn('Failed to fetch convergence image_url:', error)
      // Continue with campaign creation even if image fetch fails
    }
  }

  const { data, error } = await supabase
    .from('campaigns')
    .insert({
      ...campaign,
      id,
      clicks: 0,
      views: 0,
      sales: 0,
      status: 'Active',
      image_url: imageUrl
    })
    .select()
    .single()

  if (error) throw error

  if (campaign.originating_convergence_id) {
    // mark the convergence as used
    await supabase
      .from('convergences')
      .update({ status: 'Used' })
      .eq('id', campaign.originating_convergence_id)
  }

  return data
}
